"use client";

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`main-header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container header-flex">
        
        {/* LOGO ALS LINK ZUR HOMEPAGE */}
        <Link href="/" className="logo-link" onClick={() => setIsOpen(false)}>
          <div className="logo-container">
            <Image 
              src="/logo.png" 
              alt="bodybalance Logo" 
              width={180} 
              height={60} 
              priority 
              style={{ 
                width: 'auto', 
                height: isScrolled ? '45px' : '60px', 
                objectFit: 'contain',
                display: 'block',
                transition: 'height 0.3s ease'
              }}
              unoptimized 
            />
          </div>
        </Link>
                
        {/* BURGER MENU RECHTS */}
        <button 
          className={`burger-menu ${isOpen ? 'open' : ''}`} 
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* NAVIGATION OVERLAY */}
        <nav className={`nav-links ${isOpen ? 'nav-open' : ''}`}>
          <Link href="/" onClick={() => setIsOpen(false)}>Startseite</Link>
          <Link href="/angebote" onClick={() => setIsOpen(false)}>Angebote</Link>
          <Link href="/team" onClick={() => setIsOpen(false)}>Team</Link>
          <Link href="/kursplan" onClick={() => setIsOpen(false)}>Kursplan</Link>
          <Link href="/aktuelles" onClick={() => setIsOpen(false)}>Aktuelles</Link>
          <Link href="/kontakt" onClick={() => setIsOpen(false)}>Kontakt</Link>
        </nav>
      </div>
    </header>
  );
}